import { Injectable } from '@angular/core';
import { OrgAddOrganization } from '../model/organization';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}

@Injectable({
  providedIn: 'root'
})
export class OrgaddService {

  constructor(
    private http:HttpClient
  ) { }

  addOrg(org:OrgAddOrganization){
    return this.http.post<OrgAddOrganization>(environment.apiUrl+'/organization',JSON.stringify(org),httpOptions);
  }
}
